export const environment = {
  production: false,
  apiEndpoint: "https://uatapi.printroadtax.com",
  signalREndpoint: "https://uatapi.printroadtax.com/hubs/notification",
  cached : true,
};
